module.exports = __webpack_public_path__ + "static/media/icn-reports.2780638b.svg";